export default "__VITE_ASSET__C$ZG3vj1__"